// extracted by mini-css-extract-plugin
export default {"container":"Products_container__3qA3O","loading":"Products_loading__qk7ix","error":"Products_error__WYQbx","products":"Products_products__F0tv3"};